import { createReducer } from '@reduxjs/toolkit';

import {
  GET_VLEARN_APP_URL_REQUEST,
  GET_VLEARN_APP_URL_SUCCESS,
  GET_VLEARN_APP_URL_FAILURE,
} from './dashboard.const';

export const initialState = {
  appLoading: [],
};

const dashboardReducer = createReducer(initialState, builder => {
  builder
    .addCase(GET_VLEARN_APP_URL_REQUEST, (state, { payload = {} }) => {
      state.appLoading = state.appLoading.includes(payload.appName)
        ? state.appLoading
        : [...state.appLoading, payload.appName];
    })
    .addCase(GET_VLEARN_APP_URL_SUCCESS, (state, { payload = {} }) => {
      state.appLoading = state.appLoading.filter(item => item !== payload.appName);
    })
    .addCase(GET_VLEARN_APP_URL_FAILURE, (state, { payload = {} }) => {
      state.appLoading = state.appLoading.filter(item => item !== payload.appName);
    })
    .addDefaultCase(() => {});
});

export default dashboardReducer;
